import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type HeaderState = Readonly<{
    message: string;
}>;

const initialHeaderState: HeaderState = {
    message: "",
};

const reducer = {
    "xError/setMessage": (draft: Draft<HeaderState>, action: { message: string }) => {
        draft.message = action.message;
    },
};

const xError = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xError = xError;

export type xErrorState = {
    xError: HeaderState;
};

type xErrorReducers = {
    message: typeof xError;
};

export type xErrorActions = Parameters<xErrorReducers[keyof xErrorReducers]>[1] | AnyAction;
